import { render, staticRenderFns } from "./classQuiz.vue?vue&type=template&id=14dfa35f&scoped=true&"
import script from "./classQuiz.vue?vue&type=script&lang=js&"
export * from "./classQuiz.vue?vue&type=script&lang=js&"
import style0 from "./classQuiz.vue?vue&type=style&index=0&id=14dfa35f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14dfa35f",
  null
  
)

export default component.exports